import React, { useState, useEffect, useContext } from 'react'
import { FormattedMessage } from 'react-intl'

import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import RemoveIcon from 'assets/icons/remove-icon'
import Button from 'components/Button'
import EditIcon from 'assets/icons/edit-icon'
import ViewIcon from 'assets/icons/view-site-icon'

import {
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarDivider,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle,
  ThreatRemoveIconWrapper,
  ThreatToggleWrapper,
  ValidationDiv
} from './style'
import { defaultThreatsOptions } from './Threats'
import { useParams } from 'react-router-dom'
import { requestAllThreatTriggers } from 'api/monitoring';
import {
  CongregationHeaderCalendarIconWrapper,
  CongregationHeaderCalendarDateText
} from 'flow/siteProposal/pages/assessment/components/congregationsSection/style'
import CalendarIcon from 'assets/icons/calendar-threat-icon'
import { MonitoringContext } from 'providers/monitoring'
import ErrorIcon from 'assets/icons/error-input-trailing-icon'
import CircleIcon from 'assets/icons/circle-icon'
import ProgressComplete from 'assets/icons/progress-complete'

const ThreatsContentHeader = ({ isOpen, item, handleOpenRemoveModal, toggleAccordion, disabled, showTriggerEvaluation = false, setShowTriggerEvaluation = () => {}, setSelectedPressure = () => {}, initialOpenModalForThreatId = null, initialSelectedPressure = null, threatOptions = null, setIsLoading = () => {}, setCheckedBlankThreat = () => {}, isEditable, onBackToPressure, setIsModalOpen, isReEvaluated = false, onOpenReviewModal = () => {} }) => {
  const params = useParams()
  const [isModalOpen, setLocalIsModalOpen] = useState(false)
  const [selectedPressureNew, setSelectedPressureNew] = useState(null)
  const resolvedOptions = threatOptions || defaultThreatsOptions
  const threats = item.Level3ThreatId ? resolvedOptions.level3Threats : resolvedOptions.level2Threats
  const threatItemId = item.Level3ThreatId ? item.Level3ThreatId : item.Level2ThreatId
  const name = threats.find((element) => {
    return String(element.value) === String(threatItemId)
  })
  const [IsTriggerItemCount, setIsTriggerItemCount] = useState(0);
  const { monitoringProposalFieldValidation } = useContext(MonitoringContext)
  const invalidThreatIds = monitoringProposalFieldValidation?.sitePressure?.threatIds

  const onAddDetail = (item) => {
    const monitoringId = params?.monitoringId;
    const monitorThreatId = item?.id;
    const displayName = name ? (name.title ?? name.label) : item.name
    const timingValue = item?.SiteThreatTimingId ?? item?.siteThreatTimingId ?? item?.site_threat_timing_id ?? null
    localStorage.setItem('site_threat_timing_id', timingValue)
    // fetch trigger items; if any exist, open the details inline (preselected)
    setIsLoading(true)
    requestAllThreatTriggers(monitorThreatId, 0).then((data) => {
      const items = data?.data ? data?.data : [];
      if(data?.count > 0) {
        setIsLoading(false)
        if(items.siteSpecies.length > 0) {
          setSelectedPressure({ data: items.siteSpecies, threatItemId: monitorThreatId, displayName })
        } else {
          setSelectedPressure({ data: items.siteEcosystems, threatItemId: monitorThreatId, displayName })
        }
        setIsTriggerItemCount(data?.count)
        setShowTriggerEvaluation(true)
        if (isOpen) toggleAccordion()
      } else {
        setIsLoading(false)
        setSelectedPressure({ data: items, threatItemId: monitorThreatId, displayName })
        setShowTriggerEvaluation(true)
        if (isOpen) toggleAccordion()
      }
    });
  }

  const onReview = (reviewItem) => {
    const monitorThreatId = reviewItem?.id
    const displayName = name ? (name.title ?? name.label) : reviewItem.name
    const timingValue = reviewItem?.SiteThreatTimingId ?? reviewItem?.siteThreatTimingId ?? reviewItem?.site_threat_timing_id ?? null
    localStorage.setItem('site_threat_timing_id', timingValue)
    setIsLoading(true)
    requestAllThreatTriggers(monitorThreatId, 0).then((data) => {
      const items = data?.data ? data?.data : []
      let selectedData = items
      if (data?.count > 0) {
        selectedData = items.siteSpecies?.length > 0 ? items.siteSpecies : items.siteEcosystems
      }
      setIsLoading(false)
      onOpenReviewModal({
        data: selectedData,
        threatItemId: monitorThreatId,
        displayName,
        item: reviewItem
      })
    }).catch(() => {
      setIsLoading(false)
    })
  }

  const isReviewed = item?.isReviewed ?? item?.is_reviewed ?? true
  const isCopiedPressure = item?.previouslyAddedPressure ?? item?.previously_added_pressure ?? false
  const showCopiedReviewUi = Boolean(item.threat_trigger_exists && isReEvaluated && isEditable && isCopiedPressure)

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isModalOpen])

  // Auto-open modal if parent signalled to open this threat's modal
  useEffect(() => {
    if (initialOpenModalForThreatId && String(initialOpenModalForThreatId) === String(item.id)) {
      if (initialSelectedPressure) {
        setSelectedPressureNew(initialSelectedPressure)
      }
    }
  }, [initialOpenModalForThreatId, initialSelectedPressure, item.id])


  const truncate = (text, max = 200) => {
    if (text == null) return text
    const str = String(text)
    return str.length > max ? str.slice(0, max) + '....' : str
  }

  const handleBackToPressure = () => {
    setLocalIsModalOpen(false)
    setIsModalOpen?.(false)
    onBackToPressure?.()
    setShowTriggerEvaluation(false)
  }

  useEffect(() => {
    document.body.style.overflow = 'auto'
    return () => {
      document.body.style.overflow = 'auto'
      document.body.classList.remove('ReactModal__Body--open')
      document.body.classList.remove('modal-open')
      document.body.classList.remove('overflow-hidden')
    }
  }, [])

  return (
    <>
      {!showTriggerEvaluation && (
        <EcosystemHeaderNavbarWrapper isOpen={isOpen} data-test="threats" bottomBorder={false}>
          <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion} style={{ display: 'flex', alignItems: 'center', flex: '1 1 0', minWidth: 0, justifyContent: 'flex-start' }}>
            <EcosystemHeaderIconWrapper>
              {/* <EcosystemHeaderIcon isRejected={item.threat_trigger_exists ? true : false} /> */}
              {item.threat_trigger_exists ? <ProgressComplete /> : <CircleIcon />}
            </EcosystemHeaderIconWrapper>
            <EcosystemHeaderTitle data-test="threats-name">{truncate(name ? (name.title ?? name.label) : item.title)}</EcosystemHeaderTitle>
          </EcosystemHeaderNavbarHalfSide>
          <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion} style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', minWidth: '168px', marginTop: '1px', flexShrink: 0 }}>
              {item?.createdAt && (
                <>
                  <CongregationHeaderCalendarIconWrapper>
                    <CalendarIcon />
                  </CongregationHeaderCalendarIconWrapper>
                  <CongregationHeaderCalendarDateText style={{fontSize: '14px'}}>
                    {new Date(item.createdAt).toLocaleString('en-US', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    }).replace(',', '')}
                  </CongregationHeaderCalendarDateText>
                </>
              )}
            </div>
            <ThreatToggleWrapper isActive={isOpen} style={{marginLeft: '8px', cursor: 'pointer', flexShrink: 0 }}>
              {!isOpen ? <FormattedMessage id="expand" /> : <FormattedMessage id="close" defaultMessage="close" />}
              {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
            </ThreatToggleWrapper>
            {!disabled && (
              <>
                <EcosystemHeaderNavbarDivider />
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0, whiteSpace: 'nowrap' }}>
                {showCopiedReviewUi && !isReviewed ? (
                  <Button
                    height="34px"
                    marginTop="0"
                    type="primary"
                    onClick={(e) => {
                      e.stopPropagation()
                      onReview(item)
                    }}
                  >
                    <FormattedMessage id="review" defaultMessage="Review" />
                  </Button>
                ) : (
                  <>
                    <Button
                      height="34px"
                      marginTop="0"
                      withIcon={Boolean(item.threat_trigger_exists)}
                      type={item.threat_trigger_exists ? ('default') : ('primary')}
                      onClick={(e) => {
                        e.stopPropagation()
                        onAddDetail(item)
                        setShowTriggerEvaluation(item.threat_trigger_exists)
                      }}
                      isDisabled={!item.threat_trigger_exists && !isEditable ? true : name ? false : true}
                    >
                      {item.threat_trigger_exists && (
                        isEditable
                          ? <EditIcon style={{ marginRight: '8px' }} />
                          : <ViewIcon style={{ marginRight: '8px' }} />
                      )}
                      {item.threat_trigger_exists ? (
                        <>
                        {isEditable ?
                          <FormattedMessage id="edit" defaultMessage="&nbsp;&nbsp;edit" />
                        :
                          <FormattedMessage id="view" defaultMessage="&nbsp;&nbsp;view" />
                        }
                        </>
                      ) : (
                      <FormattedMessage id="nextTriggersAffected" defaultMessage="&nbsp;nextTriggersAffected" />
                      )}
                    </Button>
                    {showCopiedReviewUi && isReviewed && (
                      <Button
                        height="34px"
                        marginTop="0"
                        type="reviewed"
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                      >
                        <ProgressComplete />
                        <FormattedMessage id="reviewed" defaultMessage="Reviewed" />
                      </Button>
                    )}
                  </>
                )}
                </div>
                  <ThreatRemoveIconWrapper
                    delete={true}
                    data-test="remove-button"
                    isDisabled={!isEditable}
                    onClick={(e) => {
                      e.stopPropagation()
                      if (!isEditable) return;
                      handleOpenRemoveModal(item)
                      setCheckedBlankThreat(false);
                    }}
                  >
                  <RemoveIcon />
                </ThreatRemoveIconWrapper>
              </>
            )}
            {invalidThreatIds && invalidThreatIds?.includes(item?.id) && (
              <ValidationDiv>
                <ErrorIcon />
              </ValidationDiv>
            )}
          </EcosystemHeaderNavbarHalfSide>
        </EcosystemHeaderNavbarWrapper>
      )}


    </>
  )
}

export default ThreatsContentHeader
